import * as yup from 'yup';
import { dateValidation, futureDateValidation } from 'utils/date';
import { FormModel } from './CommissionDetailsPage.types';
import { FIELDS, COMMISSION_TYPE } from '../../fields/types';

export default yup.object().shape<Omit<FormModel, 'filters'>>({
  [FIELDS.COMMISSION_TERM_TYPE]: yup.string().required('This field is required.'),
  [FIELDS.COMMISSION_NAME]: yup.string().required('This field is required.'),
  [FIELDS.FEE]: yup
    .number()
    .nullable()
    .when(FIELDS.COMMISSION_TERM_TYPE, {
      is: (val: string) => val === COMMISSION_TYPE.STANDARD || val === COMMISSION_TYPE.ENHANCED,
      then: yup
        .number()
        .min(0, 'Value must be between 0% - 100%.')
        .max(100, 'Value must be between 0% - 100%.')
        .required('This field is required.'),
    }),
  [FIELDS.UPFRONT_FEE]: yup
    .number()
    .nullable()
    .min(0, 'Value must be between 0% - 100%.')
    .max(100, 'Value must be between 0% - 100%.')
    .when(FIELDS.COMMISSION_TERM_TYPE, {
      is: COMMISSION_TYPE.ONGOING,
      then: yup
        .number()
        .min(0, 'Value must be between 0% - 100%.')
        .max(100, 'Value must be between 0% - 100%.')
        .required('This field is required.'),
    }),
  [FIELDS.ONGOING_FEE]: yup
    .number()
    .nullable()
    .when(FIELDS.COMMISSION_TERM_TYPE, {
      is: COMMISSION_TYPE.ONGOING,
      then: yup
        .number()
        .min(0, 'Value must be between 0% - 100%.')
        .max(100, 'Value must be between 0% - 100%.')
        .required('This field is required.'),
    }),
  [FIELDS.FEE_END_DATE]: dateValidation(true).when(FIELDS.COMMISSION_TERM_TYPE, {
    is: COMMISSION_TYPE.ONGOING,
    then: futureDateValidation().required('This field is required.'),
  }),
  [FIELDS.PRODUCTS]: yup.array(),
});
